import React from 'react';
import { Check, CheckCheck, Clock, AlertCircle, Loader2 } from 'lucide-react';

/**
 * Message delivery status icon component
 * Similar to WhatsApp checkmarks:
 * - sending: clock icon (gray)
 * - sent: single check (gray)
 * - delivered: double check (gray)
 * - read: double check (blue)
 * - failed: alert icon (red)
 */
const MessageStatusIcon = ({ status, className = '' }) => {
  const baseClass = `w-4 h-4 ${className}`;
  
  switch (status) {
    case 'sending':
      return (
        <Loader2 
          className={`${baseClass} text-slate-500 animate-spin dark:text-zinc-400`} 
          data-testid="status-sending"
        />
      );
    
    case 'sent':
      return (
        <Check 
          className={`${baseClass} text-slate-500 dark:text-zinc-400`} 
          data-testid="status-sent"
        />
      );
    
    case 'delivered':
      return (
        <CheckCheck 
          className={`${baseClass} text-slate-500 dark:text-zinc-400`} 
          data-testid="status-delivered"
        />
      );
    
    case 'read':
      return (
        <CheckCheck 
          className={`${baseClass} text-blue-500`} 
          data-testid="status-read"
        />
      );
    
    case 'failed':
      return (
        <AlertCircle 
          className={`${baseClass} text-red-500`} 
          data-testid="status-failed"
        />
      );
    
    default:
      // For messages without status (old messages), show as sent
      return (
        <Check 
          className={`${baseClass} text-slate-500 dark:text-zinc-400`} 
          data-testid="status-default"
        />
      );
  }
};

export default MessageStatusIcon;
